import ProfileActions from '../reducer/profileRedux';
import { makeCallbacks } from './helper';

// Helper
const makeCredentialParams = credentialDetails => {
  const {
    type,
    isDefault,
    name,
    desc,
    startYear,
    endYear,
    isCurrent,
  } = credentialDetails;
  const params = {
    credential_type: type,
    is_default: isDefault,
    details: {
      name,
      detail: desc,
      start_year: startYear,
      end_year: endYear,
      is_current: isCurrent,
    },
  };

  return params;
};

const postCredential = (
  { credentialDetails },
  { onSuccess, onFailure } = {},
) => {
  const meta = {};
  const params = makeCredentialParams(credentialDetails);
  meta.callbacks = makeCallbacks({ onSuccess, onFailure });
  return ProfileActions.postCredentialRequest(params, meta);
};

const updateCredential = (
  { id, credentialDetails },
  { onSuccess, onFailure } = {},
) => {
  const meta = {};
  const params = makeCredentialParams(credentialDetails);
  meta.callbacks = makeCallbacks({ onSuccess, onFailure });
  return ProfileActions.updateCredentialRequest({ ...params, id }, meta);
};

const deleteCredential = (id, { onSuccess, onFailure } = {}) => {
  const meta = {};
  meta.callbacks = makeCallbacks({ onSuccess, onFailure });
  return ProfileActions.deleteCredentialRequest({ id }, meta);
};

export { postCredential, updateCredential, deleteCredential };
